<template>
    <div :class="{'button': true,'collectinfo': true,'collected': !fav}" onClick={this.collectInfo.bind(this)}>
         <i :class="{icon:1,i_fav:fav,i_faved:!fav}" > </i>
    </div>
</template>

<script>
export default {
    name: "Collect",
    props: ["info"],
    data () {
        return {
            text1: "收藏",
            fav: 0,
            iscollect: 0
        }
    }
}
</script>
